<template>
  <ul ref="items" class="selector" :class="{ disabled }">
    <li
      v-for="(value, key) in items"
      :key="key"
      class="item"
      :class="{ current: key == current }"
      @click="handleSelect(key)"
    >
      <!-- @slot 選択肢の書き換え -->
      <slot :item="{ key, value }">{{ value }}</slot>
    </li>
    <div
      class="ellipse"
      :style="{
        left: `calc((100% - 8px) / ${Object.keys(items).length} * ${currentIndex} + 4px)`,
        width: `calc(100% / ${Object.keys(items).length} - 4px)`,
      }"
    />
  </ul>
</template>

<script>
/**
 * セレクター
 */
export default {
  name: 'Selector',
  model: {
    prop: 'current',
    event: 'select',
  },
  props: {
    /** 選択肢 */
    items: { type: Object, required: true },
    /** 選択中のキー (v-model) */
    current: { type: [Number, String], required: true },
    /** 非活性 */
    disabled: Boolean,
  },
  computed: {
    currentIndex() {
      return this.current ? Object.keys(this.items).indexOf(`${this.current}`) : 0
    },
  },
  methods: {
    handleSelect(key) {
      if (this.disabled) return
      /**
       * 選択肢の選択 (v-model)
       * @event select
       * @type *
       */
      this.$emit('select', key)
    },
  },
}
</script>

<style lang="postcss" scoped>
.selector {
  align-items: center;
  background: var(--white);
  border: 1px solid var(--border-color);
  border-radius: 50vh;
  display: flex;
  display: grid;
  fill: var(--text-color);
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  justify-self: flex-start;
  padding: 3px;
  position: relative;
  width: fit-content;
}

.item {
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  min-width: 56px;
  padding: 0 8px;
  position: relative;
  z-index: 1;

  &.current {
    color: var(--white);
    fill: var(--white);
  }
}

.ellipse {
  background: var(--brand-color);
  border-radius: 50vh;
  bottom: 3px;
  box-sizing: border-box;
  display: flex;
  left: 4px;
  position: absolute;
  top: 3px;
  transition: left 0.2s;
}

.disabled {
  background: #eee;

  & .item {
    color: var(--light-gray);
    cursor: default;
    fill: var(--light-gray);

    &.current {
      color: var(--very-light-gray-2);
      fill: var(--very-light-gray-2);
    }
  }

  & .ellipse {
    background: var(--light-gray);
  }
}
</style>
